// extracted by mini-css-extract-plugin
module.exports = {"main":"QsrUserInfo_main__v98Qv","field":"QsrUserInfo_field__Wb1es","label":"QsrUserInfo_label__J2fOj","value":"QsrUserInfo_value__1MNy1"};